import {
  resolve,
  getSeriesColors,
  extractColors,
  createFilter
} from "@/components/charts/common";



import { createDataSource } from '@/models/data-source';

export default async function hydrator(parameters, data, chart) {

  data.template = resolve("template.value", parameters);
  data.style = resolve("style.value", parameters);
  let extractedColors = extractColors(resolve("colors.value", parameters));
  data.colors = getSeriesColors(extractedColors);
  chart.chartData.loading = true;
  // Flagged For Validation:#E53935,In Validation:#E53935,Processed:#00E676
  const dataSource = createDataSource({});
    dataSource.updateType = "api";

    let orderBy = resolve("orderBy.value", parameters);


  let sqlQuery = resolve("sqlQuery.value", parameters);
  sqlQuery = sqlQuery ? sqlQuery.trim() : "";

  const queryExist = sqlQuery ? true : false;

  let sqlFilter = createFilter(chart, parameters);

  console.log("sqlFilter", sqlFilter);

  let query = {};
  query.id = 78985888588888;

  if(orderBy && orderBy.trim() && sqlQuery) {
    sqlQuery = sqlQuery + " order by " + orderBy.trim();
  }


  query.sql = sqlQuery;
  // createSQL(sqlQuery, undefined, undefined, undefined, undefined, undefined, sqlFilter);
  //console.log("query", query);
  //  console.log("calling hydrator 7 " + chart.id);


  if(queryExist) {
    let dd = await dataSource.request(query);
    chart.response = dd;
  }
  
  // if(typeof chart.updateUI)
  // console.log("dd", dd);
  chart.chartData.lastUpdated = Date.now();
  chart.chartData.loading = false;
  chart.chartData.loaded = true;

  if(typeof chart.reload != "undefined") {
    chart.reload();
  }
}
